import React from 'react';
import {
    ColumnPickerModal,
    PickableItem,
} from '@instinet-analytics/semantic-ui-components';

import { useDispatchUpdateVisibleColumns } from 'widgets/store/grid/visibleColumns/dispatcher';
import { useIndexEventsConfigSlice } from '../../store/config/configSlice';
import {
    indexEventWidgetColumnsDefinitions,
    IndexEventWidgetGridColumn,
} from '../grid/columns';
import { initialIndexEventsConfiguration } from '../../store/config/IndexEventsWidgetConfigState';

export default function IndexEventsWidgetGridColumnPicker() {
    const {
        config: { visibleColumns },
    } = useIndexEventsConfigSlice();

    const allPickableItems: PickableItem<IndexEventWidgetGridColumn>[] =
        indexEventWidgetColumnsDefinitions.map((column) => ({
            value: column.field as IndexEventWidgetGridColumn,
            name: column.name || column.field!,
            desc: column.headerTooltip ?? column.name,
        }));

    const dispatchUpdateVisibleColumns = useDispatchUpdateVisibleColumns();

    const onUpdateVisibleColumns = (cols: IndexEventWidgetGridColumn[]) => {
        dispatchUpdateVisibleColumns(cols);
    };

    return (
        <ColumnPickerModal
            selectedValues={visibleColumns}
            defaultSelectedValues={
                initialIndexEventsConfiguration.visibleColumns
            }
            allItems={allPickableItems}
            hideGroupView={true}
            hideSearch={true}
            onUpdateSelectedValues={onUpdateVisibleColumns}
        />
    );
}
